import { combineReducers } from 'redux'
import payment from './billing/payment.reducer'
import customers from './billing/customers.reducer'
import invoices from './billing/invoices.reducer'
import subscriptions from './billing/subscriptions.reducer'
import prices from './billing/prices.reducer'
import discounts from './billing/discounts.reducer'

export default combineReducers({ payment, customers, invoices, subscriptions, prices, discounts })
